// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3VI95","content":"Consent_content__1bXYA","footer":"Consent_footer__1kASs"};